$( document ).ready(function() {
  lgf.init();
});

var lgf = {
  lgfTimeout: null,
  isSidebarAjaxClick: false,
  init: function() {
    this.productDescriptionToggle();
    this.targetChallenge();
    this.collectionSidebarActive();
    this.homeProductslider();
    this.youtubeTrigger();
    this.mobileNav();
    this.quantityCounter();
    this.faqAccordian();
    this.productQuickadd();
    this.relatedPostslider();
    this.menuShrink();
    this.showSelect();
    this.displayPrice();
  },
  homeProductslider: function() {
    $('.lgf-slider-wrapper .logo-bar').slick({
      //   centerMode: true,
      centerPadding: '60px',
      slidesToShow: 4,
      responsive: [
        {
          breakpoint: 600,
          settings: {
            arrows: false,
            centerMode: true,
            centerPadding: '25%',
            slidesToShow: 1
          }
        }
      ]
    });

  },
  productDescriptionToggle: function() {
    if($('body.template-product').length){
      $( ".product-single__description .pdp_readmore" ).click(function() {
        $(".product-single__description .low-description").hide();
        $(".product-single__description .full-description").fadeIn();
      });
      $( ".product-single__description .pdp_readless" ).click(function() {
        $('.product-single__description .full-description').hide();
        $(".product-single__description .low-description").fadeIn();
        $('html, body').animate({
          scrollTop: $("#shopify-section-product-template").offset().top
        }, 1000);
      });
    }
  }  ,
  targetChallenge: function() {
    window.onload = function () {
      if (window.location.href.indexOf("/challenge") > -1) {

        $('html, body').animate({
          scrollTop: $("#MainContent").offset().top-152
        }, 1000);
      }
    }
  },
  collectionSidebarActive: function() {

    $(document).ready(function(){
      $('ul.sub-menu-links li a.active').parent().parent().parent().addClass('current');
    });
  }
  ,
  youtubeTrigger: function() {
    $('.lgf-video-holder').on('click', function(){
      var me = $(this);
      var url = me.attr('data-embed');
      if(!$(this).hasClass('active')){
        me.html('<iframe src="'+ url +'?rel=0&amp;autoplay=1" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>');
        setTimeout(function(){
          me.addClass('active');
        }, 800);
      }
    });
  },
  mobileNav: function() {
    $('.mobile-nav-wrapper .site-nav__link--button').on('click', function(){
      var parent = $(this).closest('.site-nav--has-dropdown');
      if(!parent.find('.site-nav__dropdown').is(':visible')){
        parent.find('.site-nav__dropdown').slideDown();
        $(this).find('svg').css({transform: 'rotateX(180deg)'});
      } else {
        parent.find('.site-nav__dropdown').slideUp();
        $(this).find('svg').css({transform: 'rotateX(0deg)'});
      }
    });
  },
  quantityCounter: function() {
    $('.lgf-count-wrapper .q-plus').click(function(e){
      e.preventDefault();
      var $qfield = $('input[id=Quantity-product-template]');
      var $qfield_temp = $('input[id=lgfQuantity]'); 
      var currentVal = parseInt($qfield.val());
      if (!isNaN(currentVal)) {
        $qfield.val(currentVal + 1);
        $qfield_temp.val(currentVal + 1);
      } else {
        $qfield.val(0);
        $qfield_temp.val(0);
      }

    });
    $('.lgf-count-wrapper .q-minus').click(function(e){  
      e.preventDefault();
      var $qfield = $('input[id=Quantity-product-template]');
      var $qfield_temp = $('input[id=lgfQuantity]');                                              
      var currentVal = parseInt($qfield.val());
      if (!isNaN(currentVal) && currentVal == 1) {
        return false;
      } 
      if (!isNaN(currentVal)) {            
        $qfield.val(currentVal - 1);
        $qfield_temp.val(currentVal - 1);
      } else {
        $qfield.val(1);
        $qfield_temp.val(1);
      }

    });
  },
  faqAccordian: function() {
    //   FAQ accordian
    $('.faq-accordian-item .question').on('click', function() {
      var parent = $(this).closest('.faq-accordian-item');

      if(!parent.find('.answer').is(':visible')){
        $(this).addClass('opn');
        parent.find('.answer').slideDown();
      } else {
        $(this).removeClass('opn');
        parent.find('.answer').slideUp();
      }
    });

  },
  productQuickadd: function() {
    // $(document).on("click",".lgf-quick-add-wrap .quick-add-drop",function() {
    //   var parent = $(this).closest('.lgf-quick-add-wrap');
    //   if(!parent.find('.lgf-packs').is(':visible')){
    //     $('.lgf-quick-add-wrap .lgf-packs').slideUp();
    //     parent.find('.lgf-packs').slideDown();
    //   } else {
    //     parent.find('.lgf-packs').slideUp();
    //   }
    // });
  },
  relatedPostslider: function() {

    $('.lgf-slider-wrapper .related-posts-slider').slick({
      //   centerMode: true,
      centerPadding: '60px',
      slidesToShow: 3,
      responsive: [
        {
          breakpoint: 769,
          settings: {
            slidesToShow: 2
          }
        },
        {
          breakpoint: 600,
          settings: {
            arrows: false,
            centerMode: true,
            centerPadding: '25%',
            slidesToShow: 1
          }
        }
      ]
    });
  },
  menuShrink: function() {
    $(window).on("scroll",function(){
      if ($(window).scrollTop() > 100){
        if(!$(".site-header").hasClass("shrink")) {
          $(".site-header").addClass("shrink");
        }
      } else {
        $(".site-header").removeClass("shrink");
      }
    });
  },
  
  showSelect: function() {
    $(document).on('click','#rc-autodeliver-checkbox .check_container', function() {
      var product_id = $(this).data("product-id");

      // console.log("productID ", product_id);

      if ($("#rc-autodeliver-checkbox_" + product_id).is(":checked"))
        $("#rc_autodeliver_options_select_" + product_id).css('display', 'flex');
      else
        $("#rc_autodeliver_options_select_" + product_id).css('display', 'none');
    });
  },

  displayPrice: function() {
    $(document).on('click','.radio-product', function() {
      var product_id = $(this).data("product-id");
      var variant_id = $(this).data("value");
      var duplicated_ids = $(this).data("duplicate");      
      var dp_prices = $(this).data("dp-price");

      let regex = /\,(?!\s*?[\{\[\"\'\w])/g;
      duplicated_ids = duplicated_ids.replace(regex, '');
      dp_prices = dp_prices.replace(regex, '');
      duplicated_ids = duplicated_ids.replaceAll("'", "\"");
      dp_prices = dp_prices.replaceAll("'", "\"");
      dp_prices = JSON.parse(dp_prices);
      duplicated_ids = JSON.parse(duplicated_ids);      
      
      let price = ""
      price = dp_prices[duplicated_ids[variant_id]];
      
      $("#variant_subscription_price_" + product_id).html(price);
    });
  },
}